// extracted by mini-css-extract-plugin
export default {"main":"Accuracy_main__tqruq","formBox":"Accuracy_formBox__eEx-o","formValue":"Accuracy_formValue__CDrGR","form":"Accuracy_form__MSwbM","btnSubmit":"Accuracy_btnSubmit__l9Qrs"};